<template>
<div class="page">
<h1>Settings</h1>
<div v-if="businessListLength > 1">
<h2>Current Business</h2>
You're currently managing
  <select class="business-list" :value="currentBusinessId" @change="setCurrentBusinessId">
    <template v-for="business in businessList">
      <option :value="business.id">{{ business.displayName }}</option>
    </template>
  </select>
</div>
<br/>
<br/>
<a href="#" @click="logout">Log out</a>
</div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Settings',

    computed: {
      ...mapGetters(['currentBusinessId', 'businessListLength', 'businessList'])
    },

    methods: {
      setCurrentBusinessId (e) {
        this.$store.dispatch('setCurrentBusinessId', { id: e.target.value })
      },
      logout () {
        window.firebase.auth().signOut()
        localStorage.clear()
      }
    }
  }
</script>

<style scoped>
h2 {
  margin-top: 50px;
}
.business-list {
  border: none;
  background: #eee;
  height: 30px;
  margin-left: 3px;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  border-radius: 0px;
}
.business-list option {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/UserSettings.vue